// main js file
require('./script')

// main scss file
require('../scss/style.scss')

// icon font stylesheet
require('../icon-font/style.css')
require('../css/testimonials.css')


// WEBPACK FOOTER //
// ./assets/js/App.js